import React from 'react'

const TextAreaModalComp = React.forwardRef(({
    label,
    onChange,
    name,
    rows,
    error,
    className,
    hoverMessage,
    minLength,
    maxLength,
    disabled,
    ...rest }, 
    ref
) => (
    <div className="row mb-2 ms-1" title={hoverMessage}>
        <label
            htmlFor={name}
            className="col-12 col-md-4 border rounded col-form-label fw-bold"
            style={{ color: '#495058' }}
        >
            {label}
        </label>
        <div className="col-12 col-md-8 mt-2 mt-md-0">
            <textarea
                className={`form-control text dark ${className}`}
                id={name}
                name={name}
                ref={ref}
                rows={rows}
                required
                maxLength={maxLength}
                minLength={minLength}
                disabled={disabled}
                {...rest}
                onChange={onChange}
            />
        </div>
        {error && <p className="text-danger mt-2">{error.message}</p>}
    </div>
));


export default TextAreaModalComp